import React from "react";
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams, createSearchParams } from "react-router-dom";
import { Header } from "../../../components/header";
import { Loading } from "../../../components/loading";
import { EmptyList } from "../../../components/empty-list";
import { SearchBar } from "../../../components";
import { Table, TableHeader, TableBody, TableRow, TableCell } from "../../../components/tables";
import { SendIcon } from "../../../components/icons";
import { useJobTitles } from "../hooks";
import { cleanObject } from "../../../helpers/clean-object";

interface ISearchForm {
  search?: string;
}

export const JobTitles: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const form = useForm<ISearchForm>({
    mode: "all",
    defaultValues: {
      search: searchParams.get("search") ?? "",
    },
  });

  const onSubmit = () => {
    const values = form.getValues();
    navigate({
      pathname: "/job-titles",
      search: `?${createSearchParams(cleanObject(values))}`,
    });
  };

  const search = searchParams.get("search");
  const where: any = {};
  if (search) where.search = search;

  const { data, loading } = useJobTitles({ where });

  return (
    <>
      <Header
        title="Intitulés de poste"
        subtitle="Liste des intitulés de poste"
        buttons={[
          {
            actionText: "Nouvel intitulé",
            bgColor: "indigo",
            textColor: "white",
            link: `/job-title/create`,
            icon: <SendIcon />,
          },
        ]}
      />

      <div className="main-container">
        <SearchBar form={form} onSubmit={onSubmit} placeholder="Rechercher un intitulé..." />

        <div className="p-4 mb-6 bg-white shadow rounded overflow-x-auto">
          {loading ? (
            <Loading />
          ) : !data?.jobTitles?.results?.length ? (
            <EmptyList text="Aucun intitulé de poste" />
          ) : (
            <Table>
              <TableHeader>
                <TableRow hover={false}>
                  <TableCell header>Nom</TableCell>
                </TableRow>
              </TableHeader>
              <TableBody>
                {data?.jobTitles?.results?.map((jobTitle) => (
                  <TableRow
                    key={`job-title-${jobTitle.id}`}
                    onClick={() => navigate(`/job-title/${jobTitle.id}/update`)}
                  >
                    <TableCell>{jobTitle.name}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}
        </div>
      </div>
    </>
  );
};
